import { Suspense } from 'react'

import { RouteObject } from 'react-router-dom'

import { UserLogsLazy } from 'routes/Dashboard/routes/UserLogs/routes/UserLogs'

import { ContentLoader } from 'shared/ui/ContentLoader'

export const logsRoutes: RouteObject[] = [
  {
    path: 'logs',
    element: (
      <Suspense fallback={<ContentLoader />}>
        <UserLogsLazy />
      </Suspense>
    ),
  },
]
